import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ha-mypage l-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "会員情報 変更完了", -1)
const _hoisted_3 = { class: "ha__sec ha-mypage__sec" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "p-mypage__txt" }, "会員情報変更が完了しました。", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "p-mypage__txt" }, "このページは自動的にサービス画面に遷移します。", -1)
const _hoisted_6 = { class: "p-mypage__txt" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("※自動で遷移しない場合はお手数ですが、")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("をクリックしてください。")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("p", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("a", {
          class: "c-link--primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.callbackToken && _ctx.callbackToken(...args)))
        }, "こちら"),
        _hoisted_8
      ]),
      _createVNode(_component_router_view)
    ])
  ]))
}